import { render, staticRenderFns } from "./statement-logs.vue?vue&type=template&id=2e019364&scoped=true"
import script from "./statement-logs.vue?vue&type=script&lang=js"
export * from "./statement-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e019364",
  null
  
)

export default component.exports